import { render } from "./DetailedProject.vue?vue&type=template&id=6dc8feed&scoped=true"
import script from "./DetailedProject.vue?vue&type=script&lang=js"
export * from "./DetailedProject.vue?vue&type=script&lang=js"

import "./DetailedProject.vue?vue&type=style&index=0&id=6dc8feed&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc8feed"]])

export default __exports__